module.exports = __webpack_public_path__ + "assets/fd95a164dc1c29d8580ffaf73d129116.mp3";